import { useMemo, useState } from 'react';
import { DropLocation } from '~/lib/api/smartsend/types';
import { ToCommaList } from '../../lib/helpers/StringHelper';
import { P2GBox, P2GText, P2GLink } from '@parcel2go/core-ui';
import { useDistance } from '@parcel2go/npm-p2g-app';
import { AppCard } from '~/components/card/app-card';
import { FixedColumn } from '../FixedColumn';

interface props {
  location: DropLocation;
}

const DropShop: React.FC<props> = (props) => {
  const [open, setOpen] = useState(false);
  const { toDistance } = useDistance();
  const distance = useMemo(() => toDistance(props.location.Distance, 'small'), [toDistance, props.location.Distance]);
  return (
    <AppCard>
      <P2GBox p={2}>
        <FixedColumn
          left={<P2GText variant="body2">{distance}</P2GText>}
          right={
            <>
              <P2GBox>
                <P2GText>
                  <strong>{props.location.Name}</strong>
                </P2GText>
              </P2GBox>
              <P2GBox>
                <P2GText variant="body2">
                  {ToCommaList([props.location.Address1, props.location.Address2, props.location.Postcode])}
                </P2GText>
              </P2GBox>
              <P2GBox mt={1}>
                {open ? (
                  <P2GLink variant="body2" key="hide-times" onClick={() => setOpen(false)}>
                    Hide Times
                  </P2GLink>
                ) : (
                  <P2GLink variant="body2" key="show-times" onClick={() => setOpen(true)}>
                    Show Opening Times
                  </P2GLink>
                )}
                {open && (
                  <P2GBox pt={1}>
                    {props.location.OpeningTimes.map((o) => (
                      <P2GBox key={o.Day}>
                        {o.Day}: {o.OpeningTime} - {o.ClosingTime}
                      </P2GBox>
                    ))}
                  </P2GBox>
                )}
              </P2GBox>
            </>
          }
          width={60}
        />
      </P2GBox>
    </AppCard>
  );
};

export { DropShop };
